import {FormVersionConfigurationModel} from './form-version-configuration.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {XauditModel} from '../xaudit.model';

export class FormConfigurationModel extends XauditModel {
    DFormId: string;
    DFormName: string;
    TDOCID: number;
    enumFormCategoryID: string;
    enumFormDataSourceID: string;
    enumCustomFormID: string;
    cfgDFormVersions: FormVersionConfigurationModel[];
    enumFormCategory: EnumValidValueItemModel;
    enumFormDataSource: EnumValidValueItemModel;
    enumCustomForm: EnumValidValueItemModel;
    isRequireSignature: boolean;
    isSubmissionRequired: boolean;
    isToothRequired: boolean;
    FormOrder: number;
}
